import React from 'react';

import { bemBlock } from '../../modules/bem';
import { DropdownSeparator } from '../dropdown-separator/DropdownSeparator';
import { DropdownTitle } from '../dropdown-title/DropdownTitle';
import { LayoutColumn, LayoutColumnProps } from '../layout-column/LayoutColumn';

import './DropdownGroup.less';

const block = bemBlock('dropdown-group');

export type DropdownGroupProps = {
  title?: string;
  'data-role'?: string;
} & Pick<LayoutColumnProps<{}>, 'overflow'>;

/** @deprecated use ActionsMenu from @neptune/shared/venus-ui instead */
export const DropdownGroup: React.FC<DropdownGroupProps> = ({
  title,
  'data-role': dataRole,
  children,
  ...passProps
}) => {
  return (
    <LayoutColumn className={block()} data-role={dataRole} {...passProps}>
      <DropdownSeparator className={block('separator')} />
      {title && <DropdownTitle variant="secondary">{title}</DropdownTitle>}
      {children}
    </LayoutColumn>
  );
};
